import API from '../../api.js';

export const updatePluginSettings = async (key, settings) => {
  return await API.updatePluginSettings(key, settings);
};
export const runPluginAction = async (key, actionId) => {
  return await API.runPluginAction(key, actionId);
};
export const setPluginEnabled = async (key, next) => {
  return await API.setPluginEnabled(key, next);
};
export const importPlugin = async (
  importFile,
  overwrite = false,
  silent = false
) => {
  return await API.importPlugin(importFile, overwrite, silent);
};
export const reloadPlugins = async () => {
  return await API.reloadPlugins();
};
export const deletePluginByKey = (key) => {
  return API.deletePlugin(key);
};
export const getPluginDetailManifest = (repoId, manifestUrl) => {
  return API.getPluginDetailManifest(repoId, manifestUrl);
};
export const getPluginRepoSettings = () => {
  return API.getPluginRepoSettings();
};
export const updatePluginRepoSettings = (values) => {
  return API.updatePluginRepoSettings(values);
};
export const previewPluginRepo = (url, publicKey) => {
  return API.previewPluginRepo(url, publicKey);
};
